module.exports = __webpack_public_path__ + "static/media/ajax-loading.cb230062.gif";